import { MAX_QUOTE_CHARS } from '@wire';

/** A selection as it goes into a quote: trimmed, runs of blank lines closed
 *  up, and cut to `MAX_QUOTE_CHARS` with an ellipsis. */
export function quoteText(selected: string): string {
  const text = selected
    .replace(/\r\n?/g, '\n')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
  return text.length > MAX_QUOTE_CHARS ? `${text.slice(0, MAX_QUOTE_CHARS - 1).trimEnd()}…` : text;
}
